import {connect} from "react-redux";
import {I18nextProvider} from "react-i18next";
import React from "react";
import i18n, {setDefaultNamespaceForBrand} from "../i18next";
import {BrandContext} from "../preview/BrandContext";
import type {ApplicationState} from "../reducers";

type Props = {
	children: any,
	moduleLanguage: string,
	theme: string
};

const LangSwitchProvider = ({children, moduleLanguage, theme}: Props) => {
	const brand = React.useContext(BrandContext);
	const namespaceBrand = brand || theme;

	React.useEffect(() => {
		setDefaultNamespaceForBrand(namespaceBrand);
	}, [namespaceBrand]);

	React.useEffect(() => {
		if (moduleLanguage && (i18n.language !== moduleLanguage)) {
			i18n.changeLanguage(moduleLanguage);
		}
	}, [moduleLanguage]);

	return <I18nextProvider i18n={i18n}>{children}</I18nextProvider>;
};

function mapStateToProps(state: ApplicationState) {
	return {
		moduleLanguage: state.config.moduleLanguage,
		theme: state.config.theme
	};
}

export default connect(mapStateToProps)(LangSwitchProvider);
